import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root",
})
export class WhiteLabelService {
  private isWhitelabelSelected = false;
  private baseUrl: string = environment.apiUrlBase;

  constructor(private http: HttpClient) { }

  getWhitelabelByDomain(band_domain: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/whitelabels/domain`, {
      headers: {
        brand_domain: band_domain
      }
    })
  }

  getAllWhitelabels(): Observable<any> {
    return this.http.get(`${this.baseUrl}/whitelabels`);
  }

  toggleWhitelabelSelect() {
    this.isWhitelabelSelected = !this.isWhitelabelSelected;
  }
}
